import { ReactNode } from "react";
// Logo colorido: as telas de acesso têm fundo claro (o LogoMof do cabeçalho é todo branco).
import LogoMofCor from "assets/images/LogoMof_Cor.svg";
import { ITENS_REGRA_SENHA } from "../regraSenha";

interface CartaoAcessoProps {
  titulo: string;
  children: ReactNode;
  rodape?: ReactNode;
}

/** Moldura das telas públicas de acesso (login, esqueci a senha, nova senha) — gabarito: SignIn do legado. */
export function CartaoAcesso({ titulo, children, rodape }: CartaoAcessoProps) {
  return (
    <div
      className="d-flex flex-column justify-content-center py-4"
      style={{ minHeight: "100vh", width: "100%", backgroundColor: "#f5f7fb" }}
    >
      <div className="container-tight py-4" style={{ maxWidth: 420, width: "100%", margin: "0 auto" }}>
        <div className="text-center mb-4">
          <img src={LogoMofCor} alt="MOF" style={{ width: 160, height: 48, objectFit: "contain" }} />
        </div>
        <div className="card card-md">
          <div className="card-body">
            <h2 className="card-title text-center mb-4">{titulo}</h2>
            {children}
          </div>
        </div>
        {rodape && <div className="text-center text-muted mt-3">{rodape}</div>}
      </div>
    </div>
  );
}

/** Lista da regra da senha com o que já foi atendido marcado. */
export function RegraSenhaVisivel({ senha }: { senha: string }) {
  return (
    <ul className="list-unstyled small mb-3">
      {ITENS_REGRA_SENHA.map((item) => {
        const atende = item.atende(senha);
        return (
          <li key={item.texto} style={{ color: atende ? "#2fb344" : "#6c757d" }}>
            <i className={atende ? "fas fa-check mr-1" : "far fa-circle mr-1"} style={{ width: 16 }}></i>{" "}
            {item.texto}
          </li>
        );
      })}
    </ul>
  );
}

export function AvisoErro({ mensagem }: { mensagem: string | null }) {
  if (!mensagem) return null;
  return (
    <div className="alert alert-danger py-2" role="alert" style={{ whiteSpace: "pre-line" }}>
      {mensagem}
    </div>
  );
}
